import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "groupButton", "priceCell"]

  connect() {
    this.groupButtonTargets.forEach((btn) => {
      const values = JSON.parse(btn.dataset.selectionValuesParam || "[]")
      btn._groupMask = values.reduce((mask, v) => mask | (1 << parseInt(v)), 0)
    })
    this.#syncGroupSelection()
  }

  selectGroup(event) {
    const values = event.params.values || []
    this.checkboxTargets.forEach((cb) => {
      this.#toggleCheckbox(cb, values.includes(parseInt(cb.value)))
    })

    this.#syncGroupSelection()
    this.dispatch("change", { detail: { values: this.#getCheckedValues() } })
  }

  toggleSingle(event) {
    event.stopPropagation()
    this.#toggleCheckbox(event.target, event.target.checked)
    this.#syncGroupSelection()
    this.dispatch("change", { detail: { values: this.#getCheckedValues() } })
  }

  #toggleCheckbox(cb, isChecked) {
    cb.checked = isChecked
    if (isChecked) cb.setAttribute("checked", "checked")
    else cb.removeAttribute("checked")
  }

  #syncGroupSelection() {
    let currentMask = 0
    this.checkboxTargets.forEach((cb) => {
      if (cb.checked) currentMask |= 1 << parseInt(cb.value)
    })

    this.groupButtonTargets.forEach((btn) => {
      btn.dataset.active = btn._groupMask > 0 && btn._groupMask === currentMask
    })

    this.#highlightPriceCells()
  }

  #getCheckedValues() {
    return this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => parseInt(cb.value))
  }

  #highlightPriceCells() {
    const selectedValues = this.#getCheckedValues()

    if (this.priceCellTargets.length === 0) return

    this.priceCellTargets.forEach((cell) => {
      const seq = parseInt(cell.dataset.sequence)

      selectedValues.includes(seq)
        ? cell.classList.add("bg-zinc-100")
        : cell.classList.remove("bg-zinc-100")
    })
  }
}
